import { asyncHandler } from '../../async-handler';
import store from '../../../../store/store';
import { RequestInfo } from '../../../../interfaces/RequestInfo';
import { TARA_NOTIFICATIONS_API } from '../../../constants/central-api';

export default async function get_tara_notifications_api_call() {
  const shop_slug = store.getState().user.company.shop_slug;
  const accessToken = store.getState().auth.authorization.accessToken;
  const isWhiteLabel = store.getState().UI?.isWhiteLabel;
  let sellerToken: string;
  if (isWhiteLabel) {
    sellerToken = accessToken?.currentWhiteLabelSellerToken;
  } else {
    sellerToken = accessToken?.sellerToken;
  }

  const requestInfo: RequestInfo = {
    url: TARA_NOTIFICATIONS_API(shop_slug),
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
  };

  const actionType = 'GET_TARA_NOTIFICATIONS_API';
  const customMsg = 'Tara notifications successfully fetched.';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false
  );
  const response = res?.data;

  if (res.actionType === actionType && response.success === true) {
    return response?.data || [];
  }
  return [];
}
